export const environment = {
  title: "WaiMai - Merchant Dashboard",
  businessName: "WaiMai - BetaResto",
  appVersion: require("../../package.json").version,
  coreEndPoint: "https://mch.service.waimai.io/api",
  authEndPoint: "https://mch.service.waimai.io/api",
  altCoreEndPoint: "https://api.mch.alt.waimai.io/api", // "http://49.13.33.1:3000/api", //
  altAuthEndPoint: "https://api.mch.alt.waimai.io/api", // "http://49.13.33.1:3000/api", //

  apkUrl:
    "https://github.com/Drunkenpilot/waimai-release/raw/main/apk/app-debug.apk",

  native: true,
  production: true,
  withCredentials: true,
  mqtt: {
    hostname: "if60ec61.ala.us-east-1.emqxsl.com",
    port: 8084,
    path: "/mqtt",
    username: "local",
    password: "password",
    protocol: "wss",
    connectOnCreate: false,
  },
};
